import axios from 'axios';
 
export default axios.create({
    baseURL: '',
    httpsAgent: {
        rejectUnauthorized: false, // Disable SSL certificate verification
    },
})